"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.env = exports.isBrowser = void 0;
exports.isBrowser = 
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
typeof window !== 'undefined' || typeof self !== 'undefined' || typeof process === 'undefined'; // main and worker thread
exports.env = exports.isBrowser ? {} : process.env || {};
